var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my_mb_empty_tips"},[_c('div',{staticClass:"mb_empty_tips"},[_c('i',{staticClass:"empty_tips_img"}),_vm._v(" "),_c('div',{staticClass:"empty_tips_text"},[_vm._v(_vm._s(_vm.$t('components_my_mb_empty_tips_index_2367', [ _vm.tip ])))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32d01ebc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/my_mb_empty_tips/index.vue
// module id = null
// module chunks = 